<template>
  <section>
    <header><b :style="{background: color}"></b>{{title}}<i v-if="tips" @click="tip"></i></header>

    <div class="content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
  export default {
    name: "SectionView",

    props: {
      // 标题
      title: {
        type: String,
        require: true,
      },
      // 颜色
      color: {
        type: String,
        default: '#6CA0EC',
      },
      // 是否启用提示按钮
      tips: {
        type: Boolean,
        default: false,
      }
    },

    methods: {
      tip() {
        this.$emit('tip');
      }
    }
  }
</script>

<style lang="scss" scoped>
  section {
    border-radius: 20px;
    padding: 40px 30px;
    overflow: hidden;
    box-sizing: border-box;
    background: #FFFFFF;
    margin-bottom: 20px;

    header {
      position: relative;
      height: 36px;
      font-size: 36px;
      font-weight: 500;
      color: #333333;
      display: flex;
      align-items: center;

      b {
        content: "";
        display: block;
        width: 14px;
        height: 100%;
        background: #6CA0EC;
        border-radius: 7px;
        margin-right: 10px;
      }

      i {
        position: absolute;
        right: 0;
        width: 34px;
        height: 34px;
        background: url("../assets/question.png") no-repeat;
        background-size: 34px 34px;

        &:active {
          opacity: 0.5;
        }
      }
    }

    .content {
      position: relative;
      padding-top: 40px;
    }
  }
</style>